import { render, staticRenderFns } from "./archived-investment.component.vue?vue&type=template&id=888b7ab0&scoped=true"
import script from "./archived-investment.component.vue?vue&type=script&lang=js"
export * from "./archived-investment.component.vue?vue&type=script&lang=js"
import style0 from "./archived-investment.component.vue?vue&type=style&index=0&id=888b7ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b7ab0",
  null
  
)

export default component.exports